import { trans, getResourcePath, useSoyuzData } from '@spotahome/soyuz/client';

import {
  Section,
  ThemeProvider,
  CookiesProvider,
  ToastContainer,
  FooterSimplified,
  SpottyCat,
  UserInfoProvider,
  GoogleOneTap,
  AppBanner,
  CitiesProvider
} from '@spotahome/ui-library';

// Styles
import '@spotahome/landings-common/src/scss/init.scss';

import LazyLoginSignUpModal from '@spotahome/landings-common/src/components/LoginSignupModal';
import HeroRedesign from '@spotahome/landings-common/src/components/HeroRedesign';

import HiwGuarentee from './components/HiwGuarentee';
import HiwContentRedesign from './components/HiwContentRedesign';

const HowItWorksContainer = () => {
  const { [HowItWorksContainer.NAME]: requestedData } = useSoyuzData();
  const { deviceType, initialCookie, userId } = requestedData;

  return (
    <CookiesProvider initialCookie={initialCookie}>
      <ThemeProvider flags={{ newButtons: true }}>
        <UserInfoProvider>
          <CitiesProvider skipAllCities>
            <ToastContainer />
            {!userId && <GoogleOneTap />}
            <AppBanner source="home" deviceType={deviceType} />
            <SpottyCat />

            <HeroRedesign
              tracking="ga-how-it-works"
              title={trans('how_it_works.alt.hero.title')}
              backgroundImage={`url(${getResourcePath(
                '/images/how-it-works/how-it-works.svg'
              )})`}
              deviceType={deviceType}
            />

            <Section background="light">
              <HiwContentRedesign />
            </Section>
            <Section background="skin">
              <HiwGuarentee />
            </Section>
            <FooterSimplified />

            <LazyLoginSignUpModal />
          </CitiesProvider>
        </UserInfoProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
};

HowItWorksContainer.NAME = 'HowItWorksContainer';

HowItWorksContainer.requestData = async req => {
  return {
    data: {
      deviceType: req.device.type,
      initialCookie: req.headers.cookie,
      userId: req.userId
    }
  };
};

export default HowItWorksContainer;
